import React, { useState, useEffect, useRef, useCallback } from "react";
import "./style.css";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Modal, Button } from "react-bootstrap";
import type { } from "@mui/x-date-pickers/themeAugmentation";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import makeStyles from "@material-ui/styles/makeStyles";
import { getCptyTextField, getTickerTextField } from "../../utils/API";
import WindowedSelect from "react-windowed-select";
import { createFilter } from "react-windowed-select";
import moment from "moment";
import withCpty from "../../redux/HOC/withCpty";
import withTicker from "../../redux/HOC/withTicker";
import Snackbar from "@mui/material/Snackbar";
import { constants, messages } from "../../common/constants";
import Alert from "@mui/material/Alert";
import { useNavigate } from "react-router";
import {
  validateBorrowAndLoan,
  validateCpty,
  validateC_N,
  validateMark,
  validateProfitCenter,
  validateQuantity,
  validateRate,
  validateTermDate,
  validateTicker,
  validateValue,
} from "../../common/tradeValidations";
import _ from "lodash";
import { pageConstant } from "../../config/pageConstant";
import { calculateContractPriceFromValues, hasAccess } from "../../common/commonFunctions";

const useStyles = makeStyles({
  root: {
    "& .MuiInputBase-root": {
      padding: 0,
      border: "none",
      "& .MuiButtonBase-root": {
        padding: 0,
        paddingLeft: 10,
      },
      "& .MuiInputBase-input": {
        padding: 15,
        paddingLeft: 0,
      },
    },
  },
});
interface SubHeaderProps {
  title?: string;
  setMarkFieldEvent?: any;
  setMarkFieldisMatchEvent?: any;
  submitContract?: any;
  handleMinimize?: any;
  handlesubmitheader?: any;
  needToClearForm?: any;
  borrowAndLoneFieldLengthprop?: any;
  borrowAndLoneFieldprop?: (event: any) => any;
  counterPartyFieldprop?: (event: React.ChangeEvent<HTMLInputElement>) => any;
  TickerFieldprop?: (value: any) => any;
  QuantityFieldprop?: (event: React.ChangeEvent<HTMLInputElement>) => any;
  ContractValueFieldprop?: (event: any) => any;
  ContractValueFieldEventprop?: (event: any) => any;
  contractPriceprop?: (value: any) => any;
  contractPriceisMatchprop?: (value: any) => any;
  divTextFieldprop?: (event: React.ChangeEvent<HTMLInputElement>) => any;
  ProfitCenterFieldprop?: (event: React.ChangeEvent<HTMLInputElement>) => any;
  RateFieldprop?: (event: React.ChangeEvent<HTMLInputElement>) => any;
  MarkFieldprop?: (event: React.ChangeEvent<HTMLInputElement>) => any;
  MarkFieldEventprop?: (event: React.ChangeEvent<HTMLInputElement>) => any;
  TermDateFieldprop?: (event: React.ChangeEvent<HTMLInputElement>) => any;
  borrowAndLoneFieldisMatchprop?: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => any;
  counterPartyFieldisMatchprop?: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => any;
  TickerFieldisMatchprop?: (event: React.ChangeEvent<HTMLInputElement>) => any;
  QuantityFieldisMatchprop?: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => any;
  ContractValueFieldisMatchprop?: (event: any) => any;
  ContractValueFieldisMatchEventprop?: (event: any) => any;
  ProfitCenterFieldisMatchprop?: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => any;
  divTextFieldisMatchprop?: (event: React.ChangeEvent<HTMLInputElement>) => any;
  RateFieldisMatchprop?: (event: React.ChangeEvent<HTMLInputElement>) => any;
  MarkFieldisMatchprop?: (event: React.ChangeEvent<HTMLInputElement>) => any;
  MarkFieldisMatchEventprop?: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => any;
  TermDateFieldisMatchprop?: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => any;
  cashNonCashprop?: (event: React.ChangeEvent<HTMLInputElement>) => any;
  cashNonCashMatchprop?: (event: React.ChangeEvent<HTMLInputElement>) => any;
  cptyListProp?: any;
  tickerListProp?: any;
  errorBaLisMatch?: string;
  CounterPartyClick?: any;
  TickerSearch?: any;
  CounterPartyClickisMatch?: any;
  TickerSearchMatch?: any;
  checkRadioProp?: any;
  isSubmitDisabledToggle?: boolean;
  tickerListMap?: any;
  cptyListMap?: any;
  tickerCusipMap?: any;
}

const SubHeader = (
  {
    title,
    setMarkFieldEvent,
    setMarkFieldisMatchEvent,
    submitContract,
    handleMinimize,
    handlesubmitheader,
    needToClearForm,
    borrowAndLoneFieldprop,
    borrowAndLoneFieldLengthprop,
    counterPartyFieldprop,
    TickerFieldprop,
    QuantityFieldprop,
    ContractValueFieldprop,
    ContractValueFieldEventprop,
    contractPriceprop,
    contractPriceisMatchprop,
    divTextFieldprop,
    ProfitCenterFieldprop,
    RateFieldprop,
    MarkFieldprop,
    MarkFieldEventprop,
    TermDateFieldprop,
    borrowAndLoneFieldisMatchprop,
    counterPartyFieldisMatchprop,
    QuantityFieldisMatchprop,
    ContractValueFieldisMatchprop,
    ContractValueFieldisMatchEventprop,
    divTextFieldisMatchprop,
    ProfitCenterFieldisMatchprop,
    RateFieldisMatchprop,
    MarkFieldisMatchEventprop,
    MarkFieldisMatchprop,
    cashNonCashprop,
    cashNonCashMatchprop,
    cptyListProp,
    tickerListProp,
    errorBaLisMatch,
    checkRadioProp,
    isSubmitDisabledToggle,
    tickerListMap,
    cptyListMap,
    tickerCusipMap
  }: SubHeaderProps,
  { set_CptyData, tickerSet }: any
) => {
  const [checkedRadio, setCheckedRadio] = useState(false);
  const [borrowAndLoanField, setBorrowAndLoan] = useState("");
  const [counterPartyField, setCounterPartyField] = useState<any>("");
  const [quantityField, setQuantityField] = useState<any>();
  const [rateField, setRateField] = useState<any>();
  const [markField, setMarkField] = useState<any>("");
  const [contractValueField, setContractValueField] = useState<any>("");
  const [divTextField, setDivTextField] = useState<any>("");
  const [profitCenterField, setProfitCenterField] = useState("");
  const [termDateField, setTermDateField] = useState<any>("");
  const [cashNonCash, setCashNonCash] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [borrowAndLoanFieldisMatch, setBorrowAndLoanFieldisMatch] =
    useState("");
  const [counterPartyFieldisMatch, setCounterPartyFieldisMatch] =
    useState<any>("");
  const [quantityFieldisMatch, setQuantityFieldisMatch] = useState<any>();
  const [rateFieldisMatch, setRateFieldisMatch] = useState<any>();
  const [markFieldisMatch, setMarkFieldisMatch] = useState<any>("");
  const [contractFieldisMatch, setContractFieldisMatch] = useState<any>("");
  const [divTextFieldisMatch, setDivTextFieldisMatch] = useState<any>("");
  const [profitCenterFieldisMatch, setProfitCenterFieldisMatch] = useState("");
  const [termDateFieldisMatch, setTermDateFieldisMatch] = useState("");
  const [cashNonCashisMatch, setCashNonCashisMatch] = useState("");
  const [list, setList] = useState<any>();
  const [tickerList, setTickerList] = useState<any>();
  const [bTickerOptions, setBTickerOptions] = useState<any[]>([]);
  const [lTickerOptions, setLTickerOptions] = useState<any[]>([]);
  const [counterPartyName, setCounterPartyName] = useState("");
  const [counterPartyNameisMatch, setCounterPartyNameisMatch] = useState("");
  const [tickerName, setTickerName] = useState("");
  const [contractPrice, setContractPrice] = useState("");
  const [contractPriceisMatch, setContractPriceisMatch] = useState("");
  const [tickerPrice, setTickerPrice] = useState<any>("");
  const [minimizeTrade, setMinimizeTrade] = useState(true);
  const [submitheader, setSubmitheader] = useState(false);
  const [tickerField, setTickerField] = useState<any>("");
  const [loanValueFieldExceedStatus, setLoanValueFieldExceedStatus] =
    useState(false);
  const [loanValueFieldExceedWarningNo, setLoanValueFieldExceedWarningNo] =
    useState(false);
  const [loanValueFieldExceedWarningYes, setLoanValueFieldExceedWarningYes] =
    useState(false);
  const [markFieldExceedStatus, setMarkFieldExceedStatus] = useState(false);
  const [invalidQuantity, setInvalidQuantity] = useState(false);
  const [markFieldExceedStatusisMatch, setMarkFieldExceedStatusisMatch] =
    useState(false);
  const [errorRateSubHader, setErrorRateSubHader] = useState("");
  const [errorRateisMatchSubHader, setErrorRateisMatchSubHader] = useState("");
  const [snackbarMessage, setSnackbarMessage] = useState<any>("");
  const [tickersnackbarMessage, settickerSnackbarMessage] = useState<any>("");
  const [open, setOpen] = useState(false);
  const [isValueWarningPopUp, setValueWarningPopUp] = useState(false);
  const [isSingleTradeSubmitted, setIsSingleTradeSubmitted] = useState(false);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
  const [bSelectedTicker, setBSelectedTicker] = useState<any>(null);
  const [lSelectedTicker, setLSelectedTicker] = useState<any>(null);
  const [tickerFieldisMatch, setTickerFieldisMatch] = useState<any>("");
  const [bTickerFilteredOptions, setBTickerFilteredOptions] = useState<any[]>(
    []
  );
  const [lTickerFilteredOptions, setLTickerFilteredOptions] = useState<any[]>(
    []
  );
  const [isBTickerFocused, setIsBTickerFocused] = useState<any>(null);
  const [isTabPressed, setIsTabPressed] = useState<boolean>(false);
  const [currentFocus, setCurrentFocus] = useState("");
  const validateSubmitForm = () => {
    let isValidForm = true;
    // let isValidCptyTicker =
    //   validateCpty(counterPartyField) && validateTicker(bSelectedTicker);
    let isValidCptyTicker =
      validateCpty(counterPartyField) && validateTicker(tickerField);
    let isQuantityRateMarkValid =
      validateQuantity(quantityField) &&
      validateRate(rateField) &&
      validateMark(markField);
    let validValue = validateValue(contractValueField);
    let validCN = cashNonCash ? validateC_N(cashNonCash?.toUpperCase()) : true;
    let isValidPC = profitCenterField
      ? validateProfitCenter(profitCenterField?.toUpperCase())
      : true;
    let isValidTermDate = termDateField
      ? validateTermDate(termDateField)
      : true;
    let isValidBL = checkedRadio
      ? validateBorrowAndLoan(borrowAndLoanField)
      : true;

    isValidForm =
      isValidCptyTicker &&
      isQuantityRateMarkValid &&
      isValidBL &&
      validValue &&
      validCN &&
      isValidPC &&
      isValidTermDate;

    if (!checkedRadio) {
      let isValidCptyTickerMatch =
        validateCpty(counterPartyFieldisMatch) &&
        validateTicker(tickerFieldisMatch);
      let isValidQuantityRateMarkMatch =
        validateQuantity(quantityFieldisMatch) &&
        validateRate(rateFieldisMatch) &&
        validateMark(markFieldisMatch);
      let isValidValue = validateValue(contractFieldisMatch);
      let validCNMatch = cashNonCashisMatch
        ? validateC_N(cashNonCashisMatch?.toUpperCase())
        : true;
      let isValidPCMatch = profitCenterFieldisMatch
        ? validateProfitCenter(profitCenterFieldisMatch?.toUpperCase())
        : true;

      isValidForm =
        isValidForm &&
        isValidCptyTickerMatch &&
        isValidQuantityRateMarkMatch &&
        isValidValue &&
        validCNMatch &&
        isValidPCMatch;
    }

    return isValidForm;
  };

  const navigate = useNavigate();
  const myValueFormatter = (e: any) => {
    return e.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
  };

  const handleClick = (event: any) => {
    setCheckedRadio(event.target.checked);
    checkRadioProp(event);
  };

  useEffect(() => {
    if (borrowAndLoneFieldLengthprop) {
      borrowAndLoneFieldLengthprop(borrowAndLoanField);
    }
  }, [borrowAndLoanField]);

  useEffect(() => {
    setIsSubmitDisabled(false);
  }, [isSubmitDisabledToggle]);

  const onChangeBorrowAndLoan = (e: any) => {
    setBorrowAndLoan(e.target.value);

    if (borrowAndLoneFieldprop) {
      if (e.target.value !== "") {
        borrowAndLoneFieldprop(e.target.value);
      }
      if (e.target.value === "") {
        setBorrowAndLoanFieldisMatch("");
      }
    }

    if (e.target.value === "B") {
      setMarkField(counterPartyField.borrow_mark);
    } else if (e.target.value === "L") {
      setMarkField(counterPartyField.loan_mark);
    }
    if (borrowAndLoanField === "B") {
      setMarkField(counterPartyField.borrow_mark);
    } else if (borrowAndLoanField === "L") {
      setMarkField(counterPartyField.loan_mark);
    }
    if (e.target.value === "B" || e.target.value === "b") {
      setBorrowAndLoanFieldisMatch("L");
    } else if (e.target.value === "L" || e.target.value === "l") {
      setBorrowAndLoanFieldisMatch("B");
    }
    if (borrowAndLoanField === "B" || borrowAndLoanField === "b") {
      setBorrowAndLoanFieldisMatch("L");
    } else if (borrowAndLoanField === "L" || borrowAndLoanField === "l") {
      setBorrowAndLoanFieldisMatch("B");
    }
  };

  const handleLetterAllowedBL = (e: any) => {
    let alloweOnlyLetterBL = /[Ll]/gm.test(e.key);
    if (!alloweOnlyLetterBL) {
      e.preventDefault();
    }
  };
  const handleLetterAllowedB = (e: any) => {
    let alloweOnlyLetterBL = /[Bb]/gm.test(e.key);
    if (!alloweOnlyLetterBL) {
      e.preventDefault();
    }
  };
  const handleLetterAllowedBl = (e: any) => {
    let alloweOnlyLetterBL = /[BLbl]/gm.test(e.key);
    if (!alloweOnlyLetterBL) {
      e.preventDefault();
    }
  };
  const markFieldRef = useRef<any>(null);
  const markFieldNextRef = useRef<any>(null);
  const markFieldMismatch = useRef<any>(null);
  const markFieldNextMismatch = useRef<any>(null);
  const brandSelectRef = useRef<any>(null);
  const tickerMatchSelectRef = useRef<any>(null);
  const quantityRef = useRef<any>(null);
  const bTickerRef = useRef<any>(null);
  const bTickerInputRef = useRef<any>(null);
  const lTickerRef = useRef<any>(null);
  const lTickerInputRef = useRef<any>(null);
  const rateRef = useRef<any>(null);
  const onChangeCounterParty = (value: any) => {
    setContractValueField("");
    let contractObj = {
      cptyId: value.cptyId,
      name: "",
      borrow_mark: value.borrow_mark,
      loan_mark: value.loan_mark,
      hse_ind: value.hse_ind,
      hse_rnd: value.hse_rnd,
    };

    setCounterPartyField(contractObj);
    setCounterPartyName(value.name);
    if (borrowAndLoanField == "B" || "b") {
      setMarkField(value.borrow_mark);
      if (MarkFieldprop) {
        MarkFieldprop(value.borrow_mark);
      }
    } else if (borrowAndLoanField == "L" || "l") {
      setMarkField(value.loan_mark);
      if (MarkFieldprop) {
        MarkFieldprop(value.loan_mark);
      }
    }
    if (counterPartyFieldprop) {
      counterPartyFieldprop(value);
    }
    if (value !== null || value !== "") {
      brandSelectRef?.current?.focus();
    }
    if (value.loan_mark < 95 || value.loan_mark > 105) {
      setMarkFieldExceedStatus(true);
    }
    if (value.borrow_mark < 95 || value.borrow_mark > 105) {
      setMarkFieldExceedStatus(true);
    }
    if (_.isEmpty(tickerField)) {
      bTickerRef?.current?.focus();
    } else if (!_.isEmpty(tickerField) && !quantityField) {
      const quantityfocus: any = document.getElementById("quantityFocus");
      quantityfocus?.focus();
    } else {
      const rateFocus: any = document.getElementById("bRate");
      rateFocus?.focus();
    }
  };

  const changeFocus = (elementId: string) => {
    const element: any = document.getElementById(elementId);
    if (element) {
      element?.focus();
    }
  };

  const onChangeTicker = (value: any) => {
    setContractValueField("");
    setContractFieldisMatch("");
    let splitValue = value.value.split("/");
    let newObj = {
      value: splitValue[0],
      label: splitValue[1],
      sm_id: value.sm_id,
      updatedTime: value.updatedTime,
      name: value.name,
      price: value.price,
      date: value.date,
      cusip: value.cusip,
      ticker: value.ticker,
      cins: value.cins,
      isin: value.isin,
    };

    let cPrice: any = null;
    let cPriceisMatch: any = null;
    let cVal: any = null;
    let cValisMatch: any = null;

    if (value.price && markField && counterPartyField && quantityField) {
      cPrice = calculateContractPriceFromValues(
        value.price,
        markField,
        counterPartyField
      );
      cVal = cPrice * quantityField;
      cVal && cVal > 0 ? setContractValueField(cVal.toFixed(2)) : setContractValueField("");
      cPrice && cPrice > 0 ? setContractPrice(cPrice) : setContractPrice("");
      // if counterparty is selected for match.
      if (counterPartyFieldisMatch) {
        cPriceisMatch = calculateContractPriceFromValues(
          value.price,
          markFieldisMatch,
          counterPartyFieldisMatch
        );
        cValisMatch = cPriceisMatch * quantityField;
        setContractFieldisMatch(cValisMatch.toFixed(2));
        setContractPriceisMatch(cPriceisMatch);
        if (contractPriceisMatchprop) {
          contractPriceisMatchprop(cPriceisMatch);
        }
      }
    }

    setTickerFieldisMatch(newObj);
    setTickerField(newObj);
    setTickerName(value.name);
    setTickerPrice(value.price);
    if (TickerFieldprop) {
      TickerFieldprop(value);
    }
  };

  // const onChangeTicker = (value: any) => {
  //   setContractValueField(null);
  //   setContractFieldisMatch(null);
  //   let splitValue = value.value.split("/");
  //   let newObj = {
  //     value: splitValue[0],
  //     label: splitValue[1],
  //     sm_id: value.sm_id,
  //     updatedTime: value.updatedTime,
  //     name: value.name,
  //     price: value.price,
  //     date: value.date,
  //     cusip: value.cusip,
  //     ticker: value.ticker,
  //     cins: value.cins,
  //     isin: value.isin,
  //   };

  //   let cPrice: any = null;
  //   let cPriceisMatch: any = null;
  //   let cVal: any = null;
  //   let cValisMatch: any = null;

  //   if (value.price && markField && counterPartyField && quantityField) {
  //     cPrice = calculateContractPriceFromValues(
  //       value.price,
  //       markField,
  //       counterPartyField
  //     );
  //     cVal = cPrice * quantityField;
  //     if (cVal && cVal > 0) setContractValueField(cVal.toFixed(2));
  //     if (cPrice && cPrice > 0) setContractPrice(cPrice);
  //     // if counterparty is selected for match.
  //     if (counterPartyFieldisMatch) {
  //       cPriceisMatch = calculateContractPriceFromValues(
  //         value.price,
  //         markFieldisMatch,
  //         counterPartyFieldisMatch
  //       );
  //       cValisMatch = cPriceisMatch * quantityField;
  //       setContractFieldisMatch(cValisMatch.toFixed(2));
  //       setContractPriceisMatch(cPriceisMatch);
  //       if (contractPriceisMatchprop) {
  //         contractPriceisMatchprop(cPriceisMatch);
  //       }
  //     }
  //   }
  //   setTickerName(value.name);
  //   setTickerPrice(value.price);
  //   if (TickerFieldprop) {
  //     TickerFieldprop(value);
  //   }
  // };

  const onChangeRate = (e: any) => {
    setRateField(e.target.value);
    if (RateFieldprop) {
      RateFieldprop(e);
    }
  };

  useEffect(() => {
    if (isNaN(contractValueField)) {
      setContractValueField("");
    }
    if (isNaN(contractFieldisMatch)) {
      setContractFieldisMatch("");
    }
  }, [quantityField, quantityFieldisMatch]);

  const onChangeQuantity = (e: any) => {
    let qty = e.target?.value;
    setQuantityField(qty);
    setQuantityFieldisMatch(qty);
    if (QuantityFieldprop) {
      QuantityFieldprop(e);
    }

    if (QuantityFieldisMatchprop) {
      QuantityFieldisMatchprop(e);
    }

    if (isNaN(contractValueField)) {
      setContractValueField("");
    }
    if (e.target.value === "") {
      setContractValueField("");
      setContractFieldisMatch("");
    }
    let quantityField = parseFloat(e.target.value);
    let cPrice: any = null;
    let cPriceisMatch: any = null;
    let cVal: any = null;
    let cValisMatch: any = null;

    if (tickerPrice && markField && counterPartyField && quantityField) {
      cPrice = calculateContractPriceFromValues(
        tickerPrice,
        markField,
        counterPartyField
      );
      cVal = cPrice * quantityField;
      cVal && cVal > 0 ? setContractValueField(cVal.toFixed(2)) : setContractValueField("");
      cPrice && cPrice > 0 ? setContractPrice(cPrice) : setContractPrice("");

      if (ContractValueFieldprop) {
        ContractValueFieldprop(JSON.stringify(cVal));
      }
      if (contractPriceprop) {
        contractPriceprop(JSON.stringify(cPrice));
      }
    }
    // if counterparty is selected for match.
    if (tickerPrice && markFieldisMatch && counterPartyFieldisMatch) {
      cPriceisMatch = calculateContractPriceFromValues(
        tickerPrice,
        markFieldisMatch,
        counterPartyFieldisMatch
      );
      cValisMatch = cPriceisMatch * quantityField;
      setContractFieldisMatch(isNaN(cValisMatch) ? "" : cValisMatch.toFixed(2));
      setContractPriceisMatch(cPriceisMatch);
      if (ContractValueFieldEventprop) {
        ContractValueFieldEventprop(JSON.stringify(cValisMatch));
      }
      if (contractPriceisMatchprop) {
        contractPriceisMatchprop(JSON.stringify(cPriceisMatch));
      }
    }
  };

  useEffect(() => {
    if (isNaN(contractValueField)) {
      setContractValueField("");
    }
    if (isNaN(contractFieldisMatch)) {
      setContractValueField("");
    }
    if (!contractPrice) {
      setContractPrice("");
    }

    let cPrice: any = null;
    let cPriceisMatch: any = null;
    let cVal: any = null;
    let cValisMatch: any = null;

    if (tickerPrice && markField && counterPartyField && quantityField) {
      cPrice = calculateContractPriceFromValues(
        tickerPrice,
        markField,
        counterPartyField
      );
      cVal = cPrice * quantityField;
      setContractValueField(isNaN(cVal) ? "" : cVal.toFixed(2));
      setContractPrice(cPrice);
      if (contractPriceprop) {
        contractPriceprop(cPrice);
      }
      // if counterparty is selected for match.
    }
    if (
      tickerPrice &&
      quantityField &&
      counterPartyFieldisMatch &&
      markFieldisMatch
    ) {
      cPriceisMatch = calculateContractPriceFromValues(
        tickerPrice,
        markFieldisMatch,
        counterPartyFieldisMatch
      );
      cValisMatch = cPriceisMatch * quantityField;
      setContractFieldisMatch(isNaN(cValisMatch) ? "" : cValisMatch.toFixed(2));
      setContractPriceisMatch(cPriceisMatch);
      if (contractPriceisMatchprop) {
        contractPriceisMatchprop(cPriceisMatch);
      }
    }
  }, [
    quantityField,
    quantityFieldisMatch,
    tickerPrice,
    markField,
    markFieldisMatch,
    tickerField,
    tickerFieldisMatch,
    // bSelectedTicker,
    // lSelectedTicker,
    counterPartyField,
    counterPartyFieldisMatch,
  ]);

  const onBlurmarkfield = () => {
    if (markField && (markField < 95 || markField > 105)) {
      setMarkFieldExceedStatus(true);
    }
  };
  const quantitywarningYes = () => {
    setInvalidQuantity(false);
    setQuantityField("");
    setQuantityFieldisMatch("");
    setContractValueField("");
    setContractFieldisMatch("");
    setTimeout(() => {
      quantityRef?.current.focus();
    }, 100);
  };

  const warningNo = () => {
    setLoanValueFieldExceedWarningNo(true);
    setLoanValueFieldExceedStatus(false);
    setQuantityField("");
    setQuantityFieldisMatch("");
    setContractFieldisMatch("");
    setContractValueField("");
    setTimeout(() => {
      if (currentFocus == "lQuantity" || currentFocus == "lValue") {
        let lQuantity = document.getElementById("quantityMatch");
        lQuantity?.focus();
      } else {
        quantityRef?.current.focus();
      }
    }, 100);
  };
  const warningYes = () => {
    setLoanValueFieldExceedWarningYes(true);
    setLoanValueFieldExceedStatus(false);
    setTimeout(() => {
      changeCurrentFocus();
    }, 100);
  };

  const changeCurrentFocus = () => {
    switch (currentFocus) {
      case "bQuantity": {
        if (quantityField && rateField && contractValueField) {
          const bCN: any = document.getElementById("bCN");
          bCN?.focus();
        } else {
          rateRef?.current.focus();
        }
        break;
      }
      case "lQuantity": {
        if (quantityField && rateFieldisMatch && contractFieldisMatch) {
          const lCN: any = document.getElementById("lCN");
          lCN?.focus();
        } else {
          const rateFocusMatch: any = document.getElementById("rateMatch");
          rateFocusMatch?.focus();
        }
        break;
      }
      case "bValue": {
        const bCN: any = document.getElementById("bCN");
        bCN?.focus();
        break;
      }
      case "lValue": {
        const lCN: any = document.getElementById("lCN");
        lCN?.focus();
        break;
      }
    }
  };
  const onValueWarningOk = () => {
    setValueWarningPopUp(false);
    setQuantityField("");
    setQuantityFieldisMatch("");
    setContractValueField("");
    setContractFieldisMatch("");
    setTimeout(() => {
      quantityRef?.current.focus();
    }, 100);
  };
  const warningMarkNo = () => {
    setMarkFieldExceedStatus(false);
    setMarkField("");
    setTimeout(() => {
      markFieldRef.current.focus();
    }, 500);
  };
  const warningMarkYes = () => {
    setMarkFieldExceedStatus(false);
    setTimeout(() => {
      markFieldNextRef.current.focus();
    }, 500);
  };
  const warningMarkNoisMatch = () => {
    setMarkFieldExceedStatusisMatch(false);

    setMarkFieldisMatch("");
    setTimeout(() => {
      markFieldMismatch.current.focus();
    }, 500);
  };
  const warningMarkYesisMatch = () => {
    setMarkFieldExceedStatusisMatch(false);
    setTimeout(() => {
      markFieldNextMismatch.current.focus();
    }, 500);
  };

  const onChangeMark = (e: any) => {
    setMarkField(e.target.value);
    const cPrice = calculateContractPriceFromValues(
      tickerPrice,
      e.target.value,
      counterPartyField
    );
    const cVal = cPrice * quantityField;
    setContractValueField(isNaN(cVal) ? "" : cVal.toFixed(2));
  };

  useEffect(() => {
    setMarkFieldEvent?.(markField);
  }, [markField]);

  useEffect(() => {
    if (ContractValueFieldEventprop) {
      ContractValueFieldEventprop(contractValueField);
    }
  }, [contractValueField, markField]);

  const onChangeContractValue = (e: any) => {
    let newContractPrice: any = e.target.value / quantityField;
    setContractPrice(newContractPrice.toFixed(2));
    setContractValueField(e.target.value);
    if (ContractValueFieldEventprop) {
      ContractValueFieldEventprop(e.target.value);
    }

    if (e.target.value > 250000000) {
      setLoanValueFieldExceedStatus(true);
    }
  };

  const onBlurContractValue = () => {
    var getNumber: any = contractValueField;

    let hseIndIsone = Math.ceil(getNumber);
    let roundingNext25: any = Math.ceil(getNumber / 0.25) * 0.25;
    let roundingNext50: any = Math.ceil(getNumber / 0.5) * 0.5;
    if (counterPartyField.hse_ind === "U") {
      if (counterPartyField.hse_rnd === "1") {
        setContractValueField(hseIndIsone);
      } else if (counterPartyField.hse_rnd === 0.25) {
        setContractValueField(roundingNext25);
      } else if (counterPartyField.hse_rnd === 0.5) {
        setContractValueField(roundingNext50);
      } else {
        setContractValueField(hseIndIsone);
      }
    }
  };

  const onChangeProfitCenter = (e: any) => {
    setProfitCenterField(e.target.value);
    if (ProfitCenterFieldprop) {
      ProfitCenterFieldprop(e);
    }
  };

  const onChangeDiv = (e: any) => {
    setDivTextField(e.target.value);
    if (divTextFieldprop) {
      divTextFieldprop(e);
    }
  };

  const onChangeCashNonCash = (e: any) => {
    setCashNonCash(e.target.value);
    if (cashNonCashprop) {
      cashNonCashprop(e);
    }
    const result = e.target.value.replace(/[^a-z]/gi, "");
    setCashNonCash(result);
  };

  const onChangeCashNonCashisMatch = (e: any) => {
    setCashNonCashisMatch(e.target.value);
    if (cashNonCashMatchprop) {
      cashNonCashMatchprop(e);
    }
    const result = e.target.value.replace(/[^a-z]/gi, "");
    setCashNonCashisMatch(result);
  };

  const [errorTermDate, setErrorTermDate] = useState("");

  const onChangeTermDate = (e: any) => {
    setTermDateFieldisMatch(e);
    setTermDateField(e);
    if (TermDateFieldprop) {
      TermDateFieldprop(e);
    }
  };

  const onChangeBorrowAndLoanisMatch = (e: any) => {
    setBorrowAndLoanFieldisMatch(e.target.value);

    if (borrowAndLoneFieldisMatchprop) {
      borrowAndLoneFieldisMatchprop(e);
    }
    if (e.target.value === "") {
      setBorrowAndLoan("");
    }
    if (e.target.value === "B" || e.target.value === "b") {
      setBorrowAndLoan("L");
    } else if (e.target.value === "L" || e.target.value === "l") {
      setBorrowAndLoan("B");
    }
    if (
      borrowAndLoanFieldisMatch === "B" ||
      borrowAndLoanFieldisMatch === "b"
    ) {
      setBorrowAndLoan("L");
    } else if (
      borrowAndLoanFieldisMatch === "L" ||
      borrowAndLoanFieldisMatch === "l"
    ) {
      setBorrowAndLoan("B");
    }
    if (e.target.value === "B") {
      setMarkFieldisMatch(counterPartyFieldisMatch.borrow_mark);
    } else if (e.target.value === "L") {
      setMarkFieldisMatch(counterPartyFieldisMatch.loan_mark);
    }
    if (borrowAndLoanFieldisMatch === "B") {
      setMarkFieldisMatch(counterPartyFieldisMatch.borrow_mark);
    } else if (borrowAndLoanFieldisMatch === "L") {
      setMarkFieldisMatch(counterPartyFieldisMatch.loan_mark);
    }
  };

  const onChangeCounterPartyisMatch = (value: any) => {
    let contractObj = {
      cptyId: value.cptyId,
      name: "",
      borrow_mark: value.borrow_mark,
      loan_mark: value.loan_mark,
      hse_ind: value.hse_ind,
      hse_rnd: value.hse_rnd,
    };
    setCounterPartyFieldisMatch(contractObj);
    setCounterPartyNameisMatch(value.name);

    if (borrowAndLoanFieldisMatch == "B" || "b") {
      setMarkFieldisMatch(value.borrow_mark);

      if (MarkFieldisMatchprop) {
        MarkFieldisMatchprop(value.borrow_mark);
      }
    } else if (borrowAndLoanFieldisMatch == "L" || "l") {
      setMarkFieldisMatch(value.loan_mark);
      if (MarkFieldisMatchprop) {
        MarkFieldisMatchprop(value.loan_mark);
      }
    }
    if (counterPartyFieldisMatchprop) {
      counterPartyFieldisMatchprop(value);
    }
    if (value.loan_mark < 95 || value.loan_mark > 105) {
      setMarkFieldExceedStatusisMatch(true);
    }
    if (value.borrow_mark < 95 || value.borrow_mark > 105) {
      setMarkFieldExceedStatusisMatch(true);
    }
    // if (!lSelectedTicker || _.isEmpty(lSelectedTicker)) {
    //   lTickerRef?.current?.focus();
    if (!tickerFieldisMatch) {
      tickerMatchSelectRef?.current?.focus();
    }
    // else if (
    //   lSelectedTicker &&
    //   !_.isEmpty(lSelectedTicker) &&
    //   !quantityField
    // )
    else if (tickerFieldisMatch && !quantityField) {
      const quantityfocusMatch: any = document.getElementById("quantityMatch");
      quantityfocusMatch?.focus();
    } else {
      const rateFocusMatch: any = document.getElementById("rateMatch");
      rateFocusMatch?.focus();
    }
  };

  const onChangeRateisMatch = (e: any) => {
    setRateFieldisMatch(e.target.value);
    if (RateFieldisMatchprop) {
      RateFieldisMatchprop(e);
    }
  };

  const preventMinus = (e: any) => {
    if (e.code === constants.NumpadSubtract || e.code === constants.Minus) {
      e.preventDefault();
    }
  };

  const handleLetterSelect = (e: any) => {
    let allowedInputValue = /[cnCN]/gm.test(e.key);
    if (!allowedInputValue) {
      e.preventDefault();
    }
  };

  const handleLetterAllowe = (e: any) => {
    let alloweOnlyLetter = /[A-Z0-9a-z !@#$%&*()+=?]/gm.test(e?.key?.toUpperCase());
    if (!alloweOnlyLetter) {
      e?.preventDefault();
    }
  };
  const handleLetterAlloweDiv = (e: any) => {
    let alloweOnlyLetter = /[0-9]/gm.test(e.key);
    if (!alloweOnlyLetter) {
      e.preventDefault();
    }
  };
  const onQuantityBlur = (e: any) => {
    if (e.target?.value?.length > 12) {
      setInvalidQuantity(true);
    } else {
      let quantityField = parseFloat(e.target.value);
      let cPrice: any = null;
      let cPriceisMatch: any = null;
      let cVal: any = null;
      let cValisMatch: any = null;

      if (tickerPrice && markField && counterPartyField && quantityField) {
        cPrice = calculateContractPriceFromValues(
          tickerPrice,
          markField,
          counterPartyField
        );
        cVal = cPrice * quantityField;
        setContractValueField(isNaN(cVal) ? "" : cVal.toFixed(2));
        setContractPrice(cPrice);
        if (cVal > 999999999999.99) {
          setValueWarningPopUp(true);
        } else if (cVal > 250000000) {
          setLoanValueFieldExceedStatus(true);
        }

        if (ContractValueFieldprop) {
          ContractValueFieldprop(JSON.stringify(cVal));
        }
        if (contractPriceprop) {
          contractPriceprop(JSON.stringify(cPrice));
        }
      }
      // if counterparty is selected for match.
      if (
        counterPartyFieldisMatch &&
        tickerPrice &&
        markFieldisMatch &&
        quantityField
      ) {
        cPriceisMatch = calculateContractPriceFromValues(
          tickerPrice,
          markFieldisMatch,
          counterPartyFieldisMatch
        );
        cValisMatch = cPriceisMatch * quantityField;
        setContractFieldisMatch(isNaN(cValisMatch) ? "" : cValisMatch.toFixed(2));
        setContractPriceisMatch(cPriceisMatch);

        if (cValisMatch > 999999999999.99) {
          setValueWarningPopUp(true);
        } else if (cValisMatch > 250000000) {
          setLoanValueFieldExceedStatus(true);
        }
        if (ContractValueFieldEventprop) {
          ContractValueFieldEventprop(JSON.stringify(cValisMatch));
        }
        if (contractPriceisMatchprop) {
          contractPriceisMatchprop(JSON.stringify(cPriceisMatch));
        }
      }
    }
  };

  const onChangeQuantityisMatch = (e: any) => {
    setQuantityFieldisMatch(e.target.value);
    setQuantityField(e.target.value);

    if (QuantityFieldisMatchprop) {
      QuantityFieldisMatchprop(e);
    }
    if (isNaN(contractFieldisMatch)) {
      setContractFieldisMatch("");
    }

    var getNumber: any = e.target.value;

    var getNumberQuantity: any = parseFloat(e.target.value);

    let contractValue: any =
      (parseFloat(tickerPrice) * parseFloat(markFieldisMatch)) / 100;

    let hseIndIsone = Math.ceil(contractValue);
    let roundingNext25: any = Math.ceil(contractValue / 0.25) * 0.25;
    let roundingNext50: any = Math.ceil(contractValue / 0.5) * 0.5;

    let roundDone: any = hseIndIsone * getNumberQuantity;
    let roundDoneNext25: any = roundingNext25 * getNumberQuantity;
    let roundDoneNext50: any = roundingNext50 * getNumberQuantity;

    if (counterPartyFieldisMatch.hse_ind === "U") {
      if (counterPartyFieldisMatch.hse_rnd === "1") {
        setContractFieldisMatch(roundDone);
      } else if (counterPartyFieldisMatch.hse_rnd === 0.25) {
        setContractFieldisMatch(roundDoneNext25);
      } else if (counterPartyFieldisMatch.hse_rnd === 0.5) {
        setContractFieldisMatch(roundDoneNext50);
      } else {
        setContractFieldisMatch(roundDone);
      }
    }

    let convertedValue = myValueFormatter(roundDone);
    setContractFieldisMatch(convertedValue);
    if (ContractValueFieldisMatchprop) {
      ContractValueFieldisMatchprop(JSON.stringify(roundDone));
    }

    let contractPriceMultiplication: any =
      (parseFloat(tickerPrice) * parseFloat(markFieldisMatch)) / 100;
    setContractPriceisMatch(contractPriceMultiplication.toFixed(2));
    if (contractPriceisMatchprop) {
      contractPriceisMatchprop(contractPriceMultiplication.toFixed(2));
    }
  };
  const onBlurmarkfieldisMatch = () => {
    if (markFieldisMatch && (markFieldisMatch < 95 || markFieldisMatch > 105)) {
      setMarkFieldExceedStatusisMatch(true);
    }
  };

  const onChangeMarkisMatch = (e: any) => {
    setMarkFieldisMatch(e.target.value);
    const cPrice = calculateContractPriceFromValues(
      tickerPrice,
      e.target.value,
      counterPartyFieldisMatch
    );
    const cVal = cPrice * quantityFieldisMatch;
    setContractFieldisMatch(isNaN(cVal) ? "" : cVal.toFixed(2));
    if (MarkFieldisMatchEventprop) {
      MarkFieldisMatchEventprop(e);
    }
  };

  useEffect(() => {
    setMarkFieldisMatchEvent(markFieldisMatch);
  }, [markFieldisMatch]);

  useEffect(() => {
    if (ContractValueFieldisMatchEventprop) {
      ContractValueFieldisMatchEventprop(contractFieldisMatch);
    }
  }, [contractFieldisMatch, markFieldisMatch]);

  const onChangeContractValueisMatch = (e: any) => {
    let newContractPriceIsMatch: any = e.target.value / quantityFieldisMatch;
    setContractPriceisMatch(newContractPriceIsMatch.toFixed(2));
    if (contractPriceisMatchprop) {
      contractPriceisMatchprop(newContractPriceIsMatch.toFixed(2));
    }
    setContractFieldisMatch(e.target.value);
    if (ContractValueFieldisMatchEventprop) {
      ContractValueFieldisMatchEventprop(e.target.value);
    }
    if (e.target.value > 250000000) {
      setLoanValueFieldExceedStatus(true);
    }
  };

  const onBlurContractValueisMatch = () => {
    var getNumber: any = contractFieldisMatch;

    let hseIndIsone = Math.ceil(getNumber);
    let roundingNext25: any = Math.ceil(getNumber / 0.25) * 0.25;
    let roundingNext50: any = Math.ceil(getNumber / 0.5) * 0.5;

    if (counterPartyFieldisMatch.hse_ind === constants.Hse_ind) {
      if (counterPartyFieldisMatch.hse_rnd === constants.Hse_Rnd) {
        setContractFieldisMatch(hseIndIsone);
      } else if (counterPartyFieldisMatch.hse_rnd === 0.25) {
        setContractFieldisMatch(roundingNext25);
      } else if (counterPartyFieldisMatch.hse_rnd === 0.5) {
        setContractFieldisMatch(roundingNext50);
      } else {
        setContractFieldisMatch(hseIndIsone);
      }
    }
  };

  const onChangeProfitCenterisMatch = (e: any) => {
    setProfitCenterFieldisMatch(e.target.value);
    if (ProfitCenterFieldisMatchprop) {
      ProfitCenterFieldisMatchprop(e);
    }
  };

  const onChangeDivisMatch = (e: any) => {
    setDivTextFieldisMatch(e.target.value);
    if (divTextFieldisMatchprop) {
      divTextFieldisMatchprop(e);
    }
  };

  useEffect(() => {
    if (isNaN(contractValueField)) {
      setContractValueField("");
    }
    if (isNaN(contractFieldisMatch)) {
      setContractFieldisMatch("");
    }
  }, [contractValueField, contractFieldisMatch]);

  useEffect(() => {
    if (counterPartyField === "") {
      setMarkField("");
    }
    if (counterPartyFieldisMatch === "") {
      setMarkFieldisMatch("");
    }
  }, [counterPartyField, counterPartyFieldisMatch]);

  const selectLoanBorrow = () => {
    if (checkedRadio) {
    }
  };

  const tickerSearchOptionTemplate = (item: any) => {
    return (
      <div className="ticker-search-option">
        {item.ticker}&nbsp;&nbsp;&nbsp;{item.cusip}&nbsp;&nbsp;&nbsp;{item.name}
      </div>
    );
  };

  const bSelectedTickerTemplate = (item: any) => {
    return bTickerInputRef?.current?.value.length > 1
      ? " "
      : selectedTicker(item);
  };

  const lSelectedTickerTemplate = (item: any) => {
    return lTickerInputRef?.current?.value.length > 1
      ? " "
      : selectedTicker(item);
  };

  const selectedTicker = (item: any) => {
    return (
      <div className="ticker-search-option">
        {item.ticker}&nbsp;&nbsp;&nbsp;{item.cusip}
      </div>
    );
  };

  useEffect(() => {
    selectLoanBorrow();
  }, [borrowAndLoanField, borrowAndLoanFieldisMatch]);

  let getCptyTextFieldRes: any = "";

  const CptyList = async () => {
    getCptyTextFieldRes = await getCptyTextField();

    if (!getCptyTextFieldRes) {
      setOpen(true);
      setSnackbarMessage(messages.CPTYDownMessage);
      setDisabled(true);
    } else if (getCptyTextFieldRes.status === 200) {
      const cptydataApi = await getCptyTextFieldRes.json();
      setList(cptydataApi);
      cptyListProp(cptydataApi);
      cptyListMap(new Map(cptydataApi.map((c: any) => [c.cptyId, c])))
    } else if (getCptyTextFieldRes.status === 401) {
      navigate("/signin");
    }
  };

  const options: any = [];

  let getTickerTextFieldRes: any = "";

  const TickerList = async () => {
    getTickerTextFieldRes = await getTickerTextField();
    if (!getTickerTextFieldRes) {
      setOpen(true);
      settickerSnackbarMessage(messages.TickerDownMessage);
      setDisabled(true);
    } else if (getTickerTextFieldRes.status === 200) {
      let tickerdataApi: any = await getTickerTextFieldRes.json();
      for (let i = 0; i < tickerdataApi.length; i++) {
        let tempOptions: any = {
          value: tickerdataApi[i].ticker + "/" + tickerdataApi[i].cusip,
          label: tickerdataApi[i].name,
          ticker: tickerdataApi[i].ticker,
          cusip: tickerdataApi[i].cusip,
          name: tickerdataApi[i].name,
          price: tickerdataApi[i].price,
          sm_id: tickerdataApi[i].sm_id,
          isin: tickerdataApi[i].isin,
          cins: tickerdataApi[i].cins,
          date: tickerdataApi[i].date,
          updatedTime: tickerdataApi[i].updatedTime,
        };
        options.push(tempOptions);
      }
      setBTickerOptions([...options]);
      setLTickerOptions([...options]);
      setBTickerFilteredOptions([...options]);
      setLTickerFilteredOptions([...options]);
      setTickerList(options);
      tickerListProp(options);
      if (tickerSet) {
        tickerSet(options);
      }
      tickerCusipMap(new Map(options.map((t: any) => [t.cusip, t])))
      if (tickerListMap) {
        tickerListMap(new Map(options.map((t: any) => [t.ticker.toUpperCase(), t])))
      }
    } else if (getTickerTextFieldRes.status === 401) {
      navigate("/signin");
    }
  };

  useEffect(() => {
    TickerList();
  }, [list]);
  useEffect(() => {
    CptyList();
  }, []);

  const clearField = useCallback(() => {
    setBorrowAndLoan("");
    setBorrowAndLoanFieldisMatch("");
    setCounterPartyField("");
    setTickerField("");
    // setBSelectedTicker([]);
    setQuantityField("");
    setRateField("");
    setMarkField("");
    setContractValueField("");
    setProfitCenterField("");
    setDivTextField("");
    setTermDateField(null);
    setCashNonCash("");
    setCounterPartyFieldisMatch("");
    setTickerFieldisMatch("");
    // setLSelectedTicker([]);
    setQuantityFieldisMatch("");
    setRateFieldisMatch("");
    setMarkFieldisMatch("");
    setContractFieldisMatch("");
    setProfitCenterFieldisMatch("");
    setDivTextFieldisMatch("");
    setCashNonCashisMatch("");
    setContractPrice("");
    setContractPriceisMatch("");
    setIsSingleTradeSubmitted(false);
  }, []);

  useEffect(() => {
    if (needToClearForm) {
      clearField();
    }
  }, [clearField, needToClearForm]);

  /**
   * Check is current time in Loanet Active Hours
   * @returns
   */
  const isInBetweenActiveHours = (currentTime: Date = new Date()): boolean => {
    //EST 5:30 AM
    const startTime = new Date();
    startTime.setUTCHours(9, 30);
    // EST 07:15 PM
    const endTime = new Date();
    endTime.setUTCHours(24, 15);
    //EST 07:15 PM of FRI
    const lastWeekDayEndTime = new Date();
    lastWeekDayEndTime.setUTCHours(
      lastWeekDayEndTime.getUTCDay() === 6 ? 0 : 24,
      15
    );

    const day: number = currentTime.getUTCDay();
    const isWeekend =
      (currentTime > lastWeekDayEndTime && day === 6) || day === 0;
    //  true when it is not a weekend and time is in the active hours
    return !isWeekend && currentTime >= startTime && currentTime <= endTime;
  };

  const lonaetStatus = () => {
    if (isInBetweenActiveHours()) {
      setOpen(false);
    } else {
      setOpen(true);
      setSnackbarMessage(messages.LoanetDownMessage);
    }
  };

  useEffect(() => {
    lonaetStatus();
  }, []);
  const handleMinimizeheader = () => {
    const handleMinimizeRes = handleMinimize();
    setMinimizeTrade(handleMinimizeRes);
  };
  const handlesubmitButton = () => {
    const handlesubmit = handlesubmitheader();
    setSubmitheader(true);
  };
  const customStyles = {
    option: (provided: any, state: any) => ({
      ...provided,
      color: "#000",
      fontSize: "0.7rem",
      backgroundColor: state.isFocused ? "#EAECEF" : null,
      cursor: "pointer",
    }),
    control: (base: any, state: any) => ({
      ...base,
      fontSize: "0.8rem",
      minWidth: "9rem",
      maxWidth: "9rem",
      marginRight: "1rem",
      borderColor: "#EAECEF",
      ":hover": {
        borderColor: "#EAECEF",
      },
    }),
    valueContainer: (base: any) => ({
      ...base,
      height: "2.4rem",
    }),
    indicatorsContainer: (base: any) => ({
      ...base,
    }),
    menu: (provided: any) => ({
      ...provided,
      width: 300,
      backgroundColor: "#fff",
    }),
    input: (provided: any, state: any) => ({
      ...provided,
      height: "2rem",
    }),
  };

  const formatOptionLabel = ({
    ticker,
    name,
    cusip,
    label,
    value,
    options,
  }: any) => {
    let splitValue = value.split("/");
    return (
      <div style={{ display: "flex" }}>
        <div>{splitValue[0]}</div>
        <div style={{ color: "#000", marginLeft: "10px" }}>{splitValue[1]}</div>
        <div style={{ color: "#000", marginLeft: "10px" }}>{label}</div>
      </div>
    );
  };

  //filter for ticker and cpty
  const customFilterCpty = createFilter({ ignoreAccents: false });
  const customFilterTicker = (option: any, searchText: any) => {
    if (
      option.data.cusip.toLowerCase().startsWith(searchText.toLowerCase()) ||
      option.data.ticker.toLowerCase().startsWith(searchText.toLowerCase())
    ) {
      return true;
    } else {
      return false;
    }
  };

  const formatOptionLabelCounter = ({ cptyId, name }: any) => (
    <div style={{ display: "flex" }}>
      <div>{cptyId}</div>
      <div style={{ color: "#000", marginLeft: "10px" }}>{name}</div>
    </div>
  );
  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === constants.clickaway) {
      return;
    }

    setOpen(false);
  };

  const onBTickerInputChange = (query: any) => {
    if (query != "") {
      let tickerMatchedRows = [];
      let cusipMatchedRows = [];
      let nameMatchedRows = [];
      tickerMatchedRows = [
        ...bTickerOptions.filter((t) =>
          t.ticker.toLowerCase().startsWith(query.toLowerCase())
        ),
      ];
      cusipMatchedRows = [
        ...bTickerOptions.filter(
          (t) =>
            t.cusip.toLowerCase().startsWith(query.toLowerCase()) &&
            !t.ticker.toLowerCase().startsWith(query.toLowerCase())
        ),
      ];
      nameMatchedRows = [
        ...bTickerOptions.filter(
          (t) =>
            t.name.toLowerCase().startsWith(query.toLowerCase()) &&
            !t.cusip.toLowerCase().startsWith(query.toLowerCase()) &&
            !t.ticker.toLowerCase().startsWith(query.toLowerCase())
        ),
      ];
      let totalOptions = [
        ...tickerMatchedRows,
        ...cusipMatchedRows,
        ...nameMatchedRows,
      ];
      setBTickerFilteredOptions([...totalOptions]);
    } else {
      setBTickerFilteredOptions([...bTickerOptions]);
    }
  };

  const onLTickerInputChange = (query: any) => {
    if (query != "") {
      let tickerMatchedRows = [];
      let cusipMatchedRows = [];
      let nameMatchedRows = [];
      tickerMatchedRows = [
        ...lTickerOptions.filter((t) =>
          t.ticker.toLowerCase().startsWith(query.toLowerCase())
        ),
      ];
      cusipMatchedRows = [
        ...lTickerOptions.filter(
          (t) =>
            t.cusip.toLowerCase().startsWith(query.toLowerCase()) &&
            !t.ticker.toLowerCase().startsWith(query.toLowerCase())
        ),
      ];
      nameMatchedRows = [
        ...lTickerOptions.filter(
          (t) =>
            t.name.toLowerCase().startsWith(query.toLowerCase()) &&
            !t.cusip.toLowerCase().startsWith(query.toLowerCase()) &&
            !t.ticker.toLowerCase().startsWith(query.toLowerCase())
        ),
      ];
      let totalOptions = [
        ...tickerMatchedRows,
        ...cusipMatchedRows,
        ...nameMatchedRows,
      ];
      setLTickerFilteredOptions([...totalOptions]);
    } else {
      setLTickerFilteredOptions([...bTickerOptions]);
    }
  };

  const onBTickerChange = (event: any) => {
    setIsBTickerFocused(true);
    onTickerChange(event);
  };

  const onLTickerChange = (event: any) => {
    setIsBTickerFocused(false);
    onTickerChange(event);
  };

  const changeBTickerFocus = () => {
    if (!quantityField) {
      const quantityfocus: any = document.getElementById("quantityFocus");
      quantityfocus?.focus();
    } else {
      const rateFocus: any = document.getElementById("bRate");
      rateFocus?.focus();
    }
  };

  const changeLTickerFocus = () => {
    if (!quantityField) {
      const quantityfocusMatch: any = document.getElementById("quantityMatch");
      quantityfocusMatch?.focus();
    } else {
      const rateFocusMatch: any = document.getElementById("rateMatch");
      rateFocusMatch?.focus();
    }
  };

  const onTickerChange = (event: any) => {
    if (event?.originalEvent?.code === "Tab") {
      console.log(event?.originalEvent?.code);
      setIsTabPressed(true);
    }
    if (event?.value) {
      let selectedTicker = _.last([...event?.value]);
      if (selectedTicker) {
        setBSelectedTicker([selectedTicker]);
        setLSelectedTicker([selectedTicker]);
        onChangeTicker(selectedTicker);
      }
    }
  };

  useEffect(() => {
    if (bSelectedTicker && !_.isEmpty(bSelectedTicker)) {
      isBTickerFocused
        ? changeFocus("quantityFocus")
        : changeFocus("quantityMatch");
      onBTickerSelected(_.first(bSelectedTicker));
    }
  }, [bSelectedTicker]);

  useEffect(() => {
    if (lSelectedTicker && !_.isEmpty(lSelectedTicker)) {
      isBTickerFocused
        ? changeFocus("quantityFocus")
        : changeFocus("quantityMatch");
      onLTickerSelected(_.first(lSelectedTicker));
    }
  }, [lSelectedTicker]);

  const onBTickerFocus = () => {
    bTickerRef?.current.show();
  };

  const onLTickerFocus = () => {
    lTickerRef?.current.show();
  };

  const onBTickerOptionsHide = () => {
    if (bTickerInputRef?.current?.value) {
      bTickerInputRef.current.value = "";
      setTimeout(() => {
        setBTickerFilteredOptions([...bTickerOptions]);
      }, 200);
    }
  };

  const onLTickerOptionsHide = () => {
    if (lTickerInputRef?.current?.value) {
      lTickerInputRef.current.value = "";
      setTimeout(() => {
        setLTickerFilteredOptions([...lTickerOptions]);
      }, 200);
    }
  };

  const onBTickerSelected = (ticker: any) => {
    setBTickerFilteredOptions([...bTickerOptions]);
  };

  const onLTickerSelected = (ticker: any) => {
    setLTickerFilteredOptions([...lTickerOptions]);
  };

  const onBTickerInputClear = () => {
    setBTickerFilteredOptions([...bTickerOptions]);
    bTickerRef?.current.show();
  };

  // const onBRateFocus = (event: any) => {
  //   if (isTabPressed) {
  //     setIsTabPressed(false);
  //     if (_.isUndefined(quantityField) || _.isEmpty(quantityField))
  //       changeFocus("quantityFocus");
  //   }
  // };

  // const onLRateFocus = (event: any) => {
  //   if (isTabPressed) {
  //     setIsTabPressed(false);
  //     if (
  //       _.isUndefined(quantityFieldisMatch) ||
  //       _.isEmpty(quantityFieldisMatch)
  //     )
  //       changeFocus("quantityMatch");
  //   }
  // };

  const getTickerPlaceholder = (isBTicker: boolean) => {
    return isBTicker
      ? bSelectedTicker && bSelectedTicker.length === 1
        ? ""
        : "Search..."
      : lSelectedTicker && lSelectedTicker.length === 1
        ? ""
        : "Search...";
  };

  const onLTickerInputClear = () => {
    setLTickerFilteredOptions([...lTickerOptions]);
    lTickerRef?.current.show();
  };

  const onSubmitClicked = () => {
    setIsSubmitDisabled(true);
    setIsSingleTradeSubmitted(true);
    if (errorRateSubHader == "") {
      if (!checkedRadio && errorRateisMatchSubHader != "") {
        setIsSubmitDisabled(false);
        return;
      }
    }
    if (validateSubmitForm()) {
      setDisabled(false);
      submitContract();
    } else if (!validateSubmitForm()) {
      setIsSubmitDisabled(false);
    }
  };

  return (
    <>
      <Snackbar open={open} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="error"
          sx={{
            width: "100%",
            backgroundColor: "orange",
            textDecorationColor: "white",
          }}
        >
          <div>{snackbarMessage}</div>
          <div>{tickersnackbarMessage}</div>
        </Alert>
      </Snackbar>
      <div
        className={
          checkedRadio === true
            ? constants.subheadermatchClass
            : constants.subheaderNonmatchClass
        }
      >
        <div className="">
          <div className="minimizeIconDiv">
            <div className="subHeaderTitle drag-handle" style={{paddingLeft:'0.5rem'}}>{title}</div>
            <div className="minimizeIcon" onClick={handleMinimizeheader}>
              {minimizeTrade === false ? (
                <KeyboardArrowDownIcon />
              ) : (
                <KeyboardArrowUpIcon />
              )}
            </div>
          </div>
          {minimizeTrade === true && (
            <div style={{ display: "flex" }}>
              <div className="SubHeaderMatch">
                <input
                  type="checkbox"
                  name="match"
                  id="match"
                  className="matchRadio"
                  onChange={handleClick}
                  tabIndex={0}
                  checked={checkedRadio}
                />
                <label htmlFor="match" className="match">
                  Non-Match
                </label>
              </div>
              <div className="subheaderChildDiv">
                <div>
                  <div className="subHeaderTextFieldDiv">
                    <div className="mb-3 inputFieldDiv loanfield inputFieldDivwidth">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label inputLabelHeight"
                      >
                        {!checkedRadio ? "B" : "B/L"}
                      </label>

                      {!checkedRadio ? (
                        <input
                          className="form-control inputStyleNew inputBorderNone"
                          placeholder="B"
                          value="B"
                          readOnly={true}
                          type="text"
                          disabled
                        />
                      ) : (
                        <input
                          className="form-control inputStyleNew inputBorderNone"
                          placeholder="B/L"
                          value={borrowAndLoanField}
                          onChange={onChangeBorrowAndLoan}
                          type="text"
                          style={{ textTransform: "uppercase" }}
                          onInput={(e: any) =>
                            (e.target.value = e.target.value.slice(0, 1))
                          }
                          onKeyPress={handleLetterAllowedBl}
                        />
                      )}
                      {checkedRadio &&
                        !borrowAndLoanField &&
                        isSingleTradeSubmitted && (
                          <div className="error-style">
                            {messages.enterBLMessage}
                          </div>
                        )}
                    </div>
                    <div>
                      <div className="mb-3 inputFieldDiv">
                        <label
                          htmlFor="exampleInputEmail1"
                          className="form-label inputLabelHeight"
                        >
                          Cpty
                        </label>

                        <WindowedSelect
                          components={{
                            DropdownIndicator: () => null,
                            IndicatorSeparator: () => null,
                          }}
                          tabIndex={0}
                          onChange={onChangeCounterParty}
                          placeholder="Search..."
                          filterOption={customFilterCpty}
                          getOptionValue={(option: any) => option.name}
                          getOptionLabel={(option: any) => option.cptyId}
                          formatOptionLabel={formatOptionLabelCounter}
                          options={list}
                          windowThreshold={0}
                          styles={customStyles}
                          value={counterPartyField}
                        />
                        {counterPartyField !== "" && (
                          <div className="counterParty-Name">
                            {counterPartyName}
                          </div>
                        )}
                        {isSingleTradeSubmitted &&
                          !validateCpty(counterPartyField) && (
                            <div className="error-style">
                              {messages.singleTradeValidationMessage}
                            </div>
                          )}
                      </div>
                    </div>
                    <div>
                      <div className="mb-3 inputFieldDiv">
                        <label
                          htmlFor="exampleInputEmail1"
                          className="form-label inputLabelHeight"
                        >
                          Ticker
                        </label>
                        <div>
                          <WindowedSelect
                            components={{
                              DropdownIndicator: () => null,
                              IndicatorSeparator: () => null,
                            }}
                            tabIndex={0}
                            onChange={(value: any) => {
                              changeBTickerFocus();
                              onChangeTicker(value);
                            }}
                            placeholder="Search..."
                            filterOption={customFilterTicker}
                            ref={bTickerRef}
                            menuShouldScrollIntoView={true}
                            getOptionLabel={(option: any) => option.ticker}
                            getOptionValue={(option: any) => option.ticker}
                            options={bTickerFilteredOptions}
                            formatOptionLabel={formatOptionLabel}
                            windowThreshold={0}
                            styles={customStyles}
                            value={tickerField}
                            id="ticker"
                          />
                          {/* <AutoComplete
                            showEmptyMessage
                            autoHighlight={true}
                            emptyMessage="No options"
                            onClear={onBTickerInputClear}
                            onHide={onBTickerOptionsHide}
                            inputRef={bTickerInputRef}
                            placeholder={getTickerPlaceholder(true)}
                            virtualScrollerOptions={{ itemSize: 32 }}
                            multiple
                            value={bSelectedTicker}
                            itemTemplate={tickerSearchOptionTemplate}
                            suggestions={bTickerFilteredOptions}
                            completeMethod={bFilterTickerOptions}
                            selectedItemTemplate={bSelectedTickerTemplate}
                            onChange={(e) => onBTickerChange(e)}
                            ref={bTickerRef}
                            onFocus={onBTickerFocus}
                          /> */}
                        </div>{" "}
                        {validateTicker(tickerField) && (
                          <div className="counterParty-Name">
                            <span className="ticker-price">
                              (${tickerPrice})
                            </span>
                            <span className="ticker-name">{tickerName}</span>
                          </div>
                        )}
                        {isSingleTradeSubmitted &&
                          !validateTicker(tickerField) && (
                            <div className="error-style">
                              {messages.singleTradeValidationMessage}
                            </div>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 inputFieldDiv">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label inputLabelHeight"
                      >
                        Quantity
                      </label>
                      <input
                        ref={quantityRef}
                        className="form-control input-style inputBorderNone"
                        placeholder="Quantity"
                        value={quantityField}
                        onChange={onChangeQuantity}
                        type="number"
                        min="0"
                        onKeyPress={preventMinus}
                        id="quantityFocus"
                        onBlur={onQuantityBlur}
                        onKeyDown={validateQuantity}
                        onFocus={() => setCurrentFocus("bQuantity")}
                      />

                      {isSingleTradeSubmitted && !quantityField && (
                        <div className="error-style">
                          {messages.singleTradeValidationMessage}
                        </div>
                      )}
                      {isSingleTradeSubmitted &&
                        quantityField &&
                        (quantityField <= 0 || quantityField % 1 !== 0) && (
                          <div className="error-style">
                            {messages.enterPositiveInteger}
                          </div>
                        )}
                    </div>
                    <div className="mb-3 inputFieldDiv">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label inputLabelHeight"
                      >
                        Rate
                      </label>
                      <input
                        ref={rateRef}
                        className="form-control input-style inputBorderNone"
                        placeholder="Rate"
                        value={rateField}
                        onChange={onChangeRate}
                        type="number"
                        step="0.01"
                        id="bRate"
                      />
                      {isSingleTradeSubmitted && !rateField && (
                        <div className="error-style">
                          {messages.singleTradeValidationMessage}
                        </div>
                      )}

                      {isSingleTradeSubmitted &&
                        rateField &&
                        !validateRate(rateField) && (
                          <div className="error-style">
                            {messages.enterValidRate}
                          </div>
                        )}
                    </div>
                    <div className="mb-3 inputFieldDiv">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label inputLabelHeight"
                      >
                        Mark
                      </label>
                      <input
                        ref={markFieldRef}
                        className="form-control input-style inputBorderNone"
                        placeholder="Mark"
                        value={markField && Math.abs(markField)}
                        onChange={onChangeMark}
                        type="number"
                        id="MarkField"
                        onKeyPress={preventMinus}
                        onBlur={onBlurmarkfield}
                        tabIndex={0}
                        onInput={(e: any) =>
                          (e.target.value = e.target.value.slice(0, 3))
                        }
                      />
                      {isSingleTradeSubmitted &&
                        (!markField || (markField && markField == 0)) && (
                          <div className="error-style">
                            {messages.singleTradeValidationMessage}
                          </div>
                        )}
                      {isSingleTradeSubmitted && markField && markField < 0 && (
                        <div className="error-style">
                          {messages.enterPositiveNumberMessage}
                        </div>
                      )}
                    </div>
                    <Modal
                      size="lg"
                      centered
                      show={markFieldExceedStatus}
                      onHide={() => setMarkFieldExceedStatus(false)}
                      style={{ width: "20%", left: "40%" }}
                      tabIndex={-1}
                      backdrop="static"
                    >
                      <Modal.Header
                        style={{
                          backgroundColor: "#6a7587",
                          color: "#fff",
                          height: "3rem",
                        }}
                      >
                        <Modal.Title>Warning</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>Cparty Mark is between 95 or 105</Modal.Body>
                      <Modal.Footer>
                        <Button onClick={() => warningMarkYes()}>Yes</Button>
                        <Button onClick={() => warningMarkNo()}>No</Button>
                      </Modal.Footer>
                    </Modal>
                    <Modal
                      size="sm"
                      centered
                      show={invalidQuantity}
                      onHide={() => setInvalidQuantity(false)}
                      backdrop="static"
                    >
                      <Modal.Header
                        style={{
                          backgroundColor: "#6a7587",
                          color: "#fff",
                          height: "3rem",
                        }}
                      >
                        <Modal.Title>Warning</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div>Invalid Quantity</div>
                        <div>
                          You cannot enter a quantity greater than
                          999,999,999,999.
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button onClick={() => quantitywarningYes()}>Ok</Button>
                      </Modal.Footer>
                    </Modal>

                    <div className="mb-3 inputFieldDiv">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label inputLabelHeight"
                      >
                        Value
                      </label>
                      <input
                        className="form-control input-style inputBorderNone"
                        placeholder="Value"
                        ref={markFieldNextRef}
                        value={contractValueField}
                        onChange={onChangeContractValue}
                        type="text"
                        min="0"
                        onKeyPress={preventMinus}
                        onFocus={() => setCurrentFocus("bValue")}
                      />
                      {contractValueField !== "" && contractValueField >= 0 && (
                        <div className="ContractPricedisplay ticker-price">
                          <div>Contract Price: </div>
                          <div>(${contractPrice})</div>
                        </div>
                      )}
                      {isSingleTradeSubmitted && !contractValueField && (
                        <div className="error-style">
                          {messages.singleTradeValidationMessage}
                        </div>
                      )}
                      {isSingleTradeSubmitted &&
                        contractValueField &&
                        contractValueField < 0 && (
                          <div className="error-style">
                            {messages.enterPositiveNumberMessage}
                          </div>
                        )}
                    </div>
                    <Modal
                      size="sm"
                      centered
                      show={loanValueFieldExceedStatus}
                      onHide={() => setLoanValueFieldExceedStatus(false)}
                      backdrop="static"
                    >
                      <Modal.Header
                        style={{
                          backgroundColor: "#6a7587",
                          color: "#fff",
                          height: "3rem",
                        }}
                      >
                        <Modal.Title>Warning</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        Loan value entered is bigger than 250M. Do you want to
                        continue?
                      </Modal.Body>
                      <Modal.Footer>
                        <Button onClick={() => warningYes()}>Yes</Button>
                        <Button onClick={() => warningNo()}>No</Button>
                      </Modal.Footer>
                    </Modal>
                    <Modal
                      size="sm"
                      centered
                      show={isValueWarningPopUp}
                      onHide={() => setValueWarningPopUp(false)}
                      backdrop="static"
                    >
                      <Modal.Header
                        style={{
                          backgroundColor: "#6a7587",
                          color: "#fff",
                          height: "3rem",
                        }}
                      >
                        <Modal.Title>Warning</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        Contract value cannot exceed to 999,999,999,999.99.
                        Please update the Quantity.
                      </Modal.Body>
                      <Modal.Footer>
                        <Button onClick={() => onValueWarningOk()}>Ok</Button>
                      </Modal.Footer>
                    </Modal>
                    <div className="mb-3 inputFieldDiv inputFieldDivwidth">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label inputLabelHeight"
                      >
                        C/N
                      </label>
                      <input
                        className="form-control inputStyleNew inputBorderNone cashMargin"
                        placeholder="C"
                        value={cashNonCash}
                        onChange={onChangeCashNonCash}
                        style={{ textTransform: "uppercase" }}
                        maxLength={1}
                        onKeyPress={handleLetterSelect}
                        id="bCN"
                      />
                    </div>
                    <div className="mb-3 inputFieldDiv inputFieldDivwidthDIV">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label inputLabelHeight"
                      >
                        Div
                      </label>
                      <input
                        className="form-control inputStyleNew inputBorderNone"
                        placeholder="100"
                        maxLength={3}
                        value={divTextField}
                        onChange={onChangeDiv}
                        onKeyPress={handleLetterAlloweDiv}
                      />
                    </div>
                    <div className="mb-3 inputFieldDiv inputFieldDivwidth">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label inputLabelHeight"
                      >
                        P/C
                      </label>
                      <input
                        className="form-control inputStyleNew inputBorderNone"
                        placeholder=""
                        value={profitCenterField}
                        style={{ textTransform: "uppercase" }}
                        onChange={onChangeProfitCenter}
                        maxLength={1}
                        onKeyPress={handleLetterAllowe}
                      />
                    </div>
                    <div className=" inputFieldDiv inputDate">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label inputLabelHeight"
                      >
                        Term Date
                      </label>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          disablePast
                          openTo="day"
                          className="onFocusOutTermDateID"
                          views={["year", "month", "day"]}
                          minDate={moment().toDate()}
                          value={termDateField}
                          inputFormat="yyyy-MM-dd"
                          InputProps={{
                            notched: false,
                            style: { fontSize: 13, color: "#212529" },
                          }}
                          onChange={(newValue) => {
                            onChangeTermDate(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField
                              variant="outlined"
                              sx={{
                                "& .MuiInputBase-input": {
                                  height: "0.4rem",
                                  width: "4.4rem",
                                  border: "none",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  border: "none",
                                },
                              }}
                              style={{
                                border: "1px solid #eaecef",
                                fontSize: "0.8rem",
                                color: "#212529",
                              }}
                              className="inputStyleNew"
                              {...params}
                            />
                          )}
                        />
                      </LocalizationProvider>
                      {termDateField && !validateTermDate(termDateField) && (
                        <div className="error-style">
                          {messages.selectFutureDateMessage}
                        </div>
                      )}
                    </div>
                  </div>

                  {checkedRadio === false && (
                    <div className="subHeaderTextFieldDiv ">
                      <div className="mb-3 inputFieldDiv loanfield inputFieldDivwidth">
                        <label
                          htmlFor="exampleInputEmail1"
                          className="form-label inputLabelHeight"
                        >
                          L
                        </label>
                        <input
                          className="form-control inputStyleNew inputBorderNone"
                          aria-label="Loan"
                          placeholder="L"
                          value="L"
                          readOnly={true}
                          type="text"
                          disabled
                        />
                        <div className="error-style">{errorBaLisMatch}</div>
                      </div>
                      <div>
                        <div className="mb-3 inputFieldDiv">
                          <label
                            htmlFor="exampleInputEmail1"
                            className="form-label inputLabelHeight"
                          >
                            Cpty
                          </label>

                          <WindowedSelect
                            components={{
                              DropdownIndicator: () => null,
                              IndicatorSeparator: () => null,
                            }}
                            tabIndex={0}
                            onChange={onChangeCounterPartyisMatch}
                            placeholder="Search..."
                            filterOption={customFilterCpty}
                            getOptionValue={(option: any) => option.name}
                            getOptionLabel={(option: any) => option.cptyId}
                            formatOptionLabel={formatOptionLabelCounter}
                            options={list}
                            windowThreshold={0}
                            styles={customStyles}
                            value={counterPartyFieldisMatch}
                          />
                          {counterPartyFieldisMatch !== "" && (
                            <div className="counterParty-Name">
                              {counterPartyNameisMatch}
                            </div>
                          )}
                          {!checkedRadio &&
                            isSingleTradeSubmitted &&
                            !validateCpty(counterPartyFieldisMatch) && (
                              <div className="error-style">
                                {messages.singleTradeValidationMessage}
                              </div>
                            )}
                        </div>
                      </div>
                      <div>
                        <div className="mb-3 inputFieldDiv">
                          <label
                            htmlFor="exampleInputEmail1"
                            className="form-label inputLabelHeight"
                          >
                            Ticker
                          </label>
                          <div>
                            <WindowedSelect
                              components={{
                                DropdownIndicator: () => null,
                                IndicatorSeparator: () => null,
                              }}
                              tabIndex={0}
                              onChange={(value:any) => {
                                changeLTickerFocus();
                                onChangeTicker(value);
                              }}
                              placeholder="Search..."
                              options={tickerList}
                              formatOptionLabel={formatOptionLabel}
                              windowThreshold={0}
                              filterOption={customFilterTicker}
                              styles={customStyles}
                              value={tickerFieldisMatch}
                              getOptionLabel={(option: any) => option.ticker}
                              getOptionValue={(option: any) => option.ticker}
                              id="tickerMatch"
                              ref={tickerMatchSelectRef}
                            />
                          </div>
                          {validateTicker(tickerFieldisMatch) && (
                            <div className="counterParty-Name">
                              <span className="ticker-price">
                                (${tickerPrice})
                              </span>
                              <span className="ticker-name">{tickerName}</span>
                            </div>
                          )}
                          {!checkedRadio &&
                            isSingleTradeSubmitted &&
                            !validateTicker(tickerFieldisMatch) && (
                              <div className="error-style">
                                {messages.singleTradeValidationMessage}
                              </div>
                            )}
                        </div>
                      </div>
                      <div className="mb-3 inputFieldDiv">
                        <label
                          htmlFor="exampleInputEmail1"
                          className="form-label inputLabelHeight"
                        >
                          Quantity
                        </label>
                        <input
                          className="form-control input-style inputBorderNone"
                          placeholder="Quantity"
                          value={quantityField}
                          onChange={onChangeQuantity}
                          type="number"
                          min="0"
                          onKeyPress={preventMinus}
                          onBlur={onQuantityBlur}
                          onKeyDown={validateQuantity}
                          id="quantityMatch"
                          onFocus={() => setCurrentFocus("lQuantity")}
                        />
                        {!checkedRadio &&
                          isSingleTradeSubmitted &&
                          !quantityField && (
                            <div className="error-style">
                              {messages.singleTradeValidationMessage}
                            </div>
                          )}
                        {!checkedRadio &&
                          isSingleTradeSubmitted &&
                          quantityField &&
                          (quantityField <= 0 || quantityField % 1 !== 0) && (
                            <div className="error-style">
                              {messages.enterPositiveInteger}
                            </div>
                          )}
                      </div>
                      <div className="mb-3 inputFieldDiv">
                        <label
                          htmlFor="exampleInputEmail1"
                          className="form-label inputLabelHeight"
                        >
                          Rate
                        </label>
                        <input
                          className="form-control input-style inputBorderNone"
                          placeholder="Rate"
                          value={rateFieldisMatch}
                          onChange={onChangeRateisMatch}
                          type="number"
                          step="0.01"
                          id="rateMatch"
                        />
                        {!checkedRadio &&
                          isSingleTradeSubmitted &&
                          !rateFieldisMatch && (
                            <div className="error-style">
                              {messages.singleTradeValidationMessage}
                            </div>
                          )}

                        {!checkedRadio &&
                          isSingleTradeSubmitted &&
                          rateFieldisMatch &&
                          !validateRate(rateFieldisMatch) && (
                            <div className="error-style">
                              {messages.enterValidRate}
                            </div>
                          )}
                      </div>
                      <div className="mb-3 inputFieldDiv">
                        <label
                          htmlFor="exampleInputEmail1"
                          className="form-label inputLabelHeight"
                        >
                          Mark
                        </label>
                        <input
                          className="form-control input-style inputBorderNone"
                          placeholder="Mark"
                          ref={markFieldMismatch}
                          value={markFieldisMatch}
                          onChange={onChangeMarkisMatch}
                          type="number"
                          onKeyPress={preventMinus}
                          onBlur={onBlurmarkfieldisMatch}
                          onInput={(e: any) =>
                            (e.target.value = e.target.value.slice(0, 3))
                          }
                        />
                        {isSingleTradeSubmitted &&
                          (!markFieldisMatch ||
                            (markFieldisMatch && markFieldisMatch == 0)) && (
                            <div className="error-style">
                              {messages.singleTradeValidationMessage}
                            </div>
                          )}
                        {!checkedRadio &&
                          isSingleTradeSubmitted &&
                          markFieldisMatch &&
                          markFieldisMatch < 0 && (
                            <div className="error-style">
                              {messages.enterPositiveNumberMessage}
                            </div>
                          )}
                      </div>
                      <Modal
                        size="lg"
                        centered
                        show={markFieldExceedStatusisMatch}
                        onHide={() => setMarkFieldExceedStatusisMatch(false)}
                        // className="adjustModal"
                        style={{ top: "15%", width: "20%", left: "40%" }}
                        tabIndex={-1}
                        backdrop="static"
                      >
                        <Modal.Header
                          style={{
                            backgroundColor: "#6a7587",
                            color: "#fff",
                            height: "3rem",
                          }}
                        >
                          <Modal.Title>Warning</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          Cparty Mark is between 95 or 105
                        </Modal.Body>
                        <Modal.Footer>
                          <Button onClick={() => warningMarkYesisMatch()}>
                            Yes
                          </Button>
                          <Button onClick={() => warningMarkNoisMatch()}>
                            No
                          </Button>
                        </Modal.Footer>
                      </Modal>
                      <div className="mb-3 inputFieldDiv">
                        <label
                          htmlFor="exampleInputEmail1"
                          className="form-label inputLabelHeight"
                        >
                          Value
                        </label>
                        <input
                          className="form-control input-style inputBorderNone"
                          placeholder="Value"
                          ref={markFieldNextMismatch}
                          value={contractFieldisMatch}
                          onChange={onChangeContractValueisMatch}
                          type="text"
                          min="0"
                          onKeyPress={preventMinus}
                          onFocus={() => setCurrentFocus("lValue")}
                        />
                        {contractFieldisMatch !== "" &&
                          contractFieldisMatch >= 0 && (
                            <div className="ContractPricedisplay ticker-price">
                              <div>Contract Price: </div>
                              <div>(${contractPriceisMatch})</div>
                            </div>
                          )}
                        {isSingleTradeSubmitted && !contractFieldisMatch && (
                          <div className="error-style">
                            {messages.singleTradeValidationMessage}
                          </div>
                        )}
                        {isSingleTradeSubmitted &&
                          contractFieldisMatch &&
                          contractFieldisMatch < 0 && (
                            <div className="error-style">
                              {messages.enterPositiveNumberMessage}
                            </div>
                          )}
                      </div>
                      <div className="mb-3 inputFieldDiv inputFieldDivwidth">
                        <label
                          htmlFor="exampleInputEmail1"
                          className="form-label inputLabelHeight"
                        >
                          C/N
                        </label>
                        <input
                          className="form-control inputStyleNew inputBorderNone"
                          placeholder="C"
                          value={cashNonCashisMatch}
                          onChange={onChangeCashNonCashisMatch}
                          style={{ textTransform: "uppercase" }}
                          maxLength={1}
                          onKeyPress={handleLetterSelect}
                          id="lCN"
                        />
                      </div>
                      <div className="mb-3 inputFieldDiv inputFieldDivwidthDIV">
                        <label
                          htmlFor="exampleInputEmail1"
                          className="form-label inputLabelHeight"
                        >
                          Div
                        </label>
                        <input
                          className="form-control inputStyleNew inputBorderNone"
                          placeholder="100"
                          maxLength={3}
                          value={divTextFieldisMatch}
                          onChange={onChangeDivisMatch}
                          onKeyPress={handleLetterAlloweDiv}
                        />
                      </div>
                      <div className="mb-3 inputFieldDiv inputFieldDivwidth">
                        <label
                          htmlFor="exampleInputEmail1"
                          className="form-label inputLabelHeight"
                        >
                          P/C
                        </label>
                        <input
                          className="form-control inputStyleNew inputBorderNone"
                          placeholder=""
                          value={profitCenterFieldisMatch}
                          onChange={onChangeProfitCenterisMatch}
                          style={{ textTransform: "uppercase" }}
                          maxLength={1}
                          onKeyPress={handleLetterAllowe}
                        />
                      </div>
                      <div className="mb-3 inputFieldDiv inputDate">
                        <label
                          htmlFor="exampleInputEmail1"
                          className="form-label inputLabelHeight"
                        >
                          Term Date
                        </label>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DesktopDatePicker
                            openTo="day"
                            views={["year", "month", "day"]}
                            value={termDateField}
                            inputFormat="yyyy-MM-dd"
                            minDate={moment().toDate()}
                            onChange={(newValue) => {
                              onChangeTermDate(newValue);
                            }}
                            disablePast
                            InputProps={{
                              notched: false,
                              style: { fontSize: 13, color: "#212529" },
                            }}
                            renderInput={(params) => (
                              <TextField
                                sx={{
                                  "& .MuiInputBase-input": {
                                    height: "0.4rem",
                                    width: "4.4rem",
                                  },
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                  },
                                }}
                                style={{
                                  border: "1px solid #eaecef",
                                  fontSize: "0.8rem",
                                  color: "#212529",
                                }}
                                className="inputStyleNew"
                                {...params}
                              />
                            )}
                          />
                        </LocalizationProvider>
                        {termDateField && !validateTermDate(termDateField) && (
                          <div className="error-style">
                            {messages.selectFutureDateMessage}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
                <div className="textField-submitBtn">
                  <button
                    type="submit"
                    disabled={!hasAccess([`${pageConstant.TRADE_BOOKING}_RW`,`${pageConstant.TRADE_BOOKING}_ADMIN`]) || isSubmitDisabled}
                    className="btn btn-primary SubmitButton"
                    onClick={onSubmitClicked}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default withTicker(withCpty(SubHeader));

